"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return ((0, vue_2.pushScopeId)("data-v-744f1b1c"), n = n(), (0, vue_2.popScopeId)(), n); };
var _hoisted_1 = { class: "container" };
var _hoisted_2 = {
    key: 0,
    class: "row"
};
var _hoisted_3 = { class: "col-12" };
var _hoisted_4 = {
    class: "alert alert-danger",
    role: "alert"
};
var _hoisted_5 = { class: "row" };
var _hoisted_6 = { class: "col-6" };
var _hoisted_7 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("p", { class: "text-muted" }, "De", -1); });
var _hoisted_8 = { class: "col-6" };
var _hoisted_9 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("p", { class: "text-muted" }, "A", -1); });
var _hoisted_10 = { class: "row" };
var _hoisted_11 = { class: "col-sm-12" };
var _hoisted_12 = { class: "table table-striped" };
var _hoisted_13 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("thead", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("tr", null, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, "Service"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, "Prix unitaire"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, "Taxe Spécifique"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, "Quantité"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, "Total")
    ])
], -1); });
var _hoisted_14 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("td", { colspan: "4" }, " Ajouter un nouveau service ", -1); });
var _hoisted_15 = [
    _hoisted_14
];
var _hoisted_16 = { class: "col-sm-6" };
var _hoisted_17 = { class: "list-group list-group-flush" };
var _hoisted_18 = { class: "list-group-item border-0" };
var _hoisted_19 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("option", {
    value: "",
    selected: ""
}, "Pas de AIB", -1); });
var _hoisted_20 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("option", { value: "A" }, "AIB A (1%)", -1); });
var _hoisted_21 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("option", { value: "B" }, "AIB B (5%)", -1); });
var _hoisted_22 = [
    _hoisted_19,
    _hoisted_20,
    _hoisted_21
];
var _hoisted_23 = { class: "list-group-item" };
var _hoisted_24 = /*#__PURE__*/ (0, vue_2.createStaticVNode)("<option selected data-v-744f1b1c>--- Méthode de paiement ---</option><option value=\"ESPECES\" data-v-744f1b1c>Espèce</option><option value=\"VIREMENT\" data-v-744f1b1c>Virement Bancaire</option><option value=\"CARTEBANCAIRE\" data-v-744f1b1c>Carte Bancaire</option><option value=\"CHEQUES\" data-v-744f1b1c>Chêque</option><option value=\"MOBILEMONEY\" data-v-744f1b1c>Mobile Money</option><option value=\"CREDIT\" data-v-744f1b1c>Crédit</option><option value=\"AUTRE\" data-v-744f1b1c>Autre</option>", 8);
var _hoisted_32 = [
    _hoisted_24
];
var _hoisted_33 = { class: "list-group-item" };
var _hoisted_34 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("option", {
    selected: "",
    value: "FV"
}, "Facture de vente", -1); });
var _hoisted_35 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("option", { value: "EV" }, "Facture de vente à l'exportation", -1); });
var _hoisted_36 = [
    _hoisted_34,
    _hoisted_35
];
var _hoisted_37 = { class: "list-group-item" };
var _hoisted_38 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("option", {
    selected: "",
    value: "draft"
}, "Facture Pro format", -1); });
var _hoisted_39 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("option", { value: "confirmed" }, "Facture Définitive", -1); });
var _hoisted_40 = [
    _hoisted_38,
    _hoisted_39
];
var _hoisted_41 = { class: "col-sm-4 offset-md-2" };
var _hoisted_42 = { class: "form-group" };
var _hoisted_43 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("label", {
    for: "discount",
    class: "form-label"
}, "Remise", -1); });
var _hoisted_44 = { class: "list-group list-group-flush" };
var _hoisted_45 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("li", { class: "list-group-item list-group-heading" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("b", null, "Total de la facture")
], -1); });
var _hoisted_46 = { class: "list-group-item" };
var _hoisted_47 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("span", null, "Sous total", -1); });
var _hoisted_48 = { class: "ms-auto" };
var _hoisted_49 = { class: "list-group-item" };
var _hoisted_50 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("span", null, "TOTAL", -1); });
var _hoisted_51 = ["value"];
var vue_3 = require("vue");
var ClientSelector_vue_1 = __importDefault(require("./ClientSelector.vue"));
var CompanySelector_vue_1 = __importDefault(require("./CompanySelector.vue"));
var ServiceItem_vue_1 = __importDefault(require("./ServiceItem.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'CreateInvoice',
    setup: function (__props) {
        var services = (0, vue_3.ref)([]);
        var discount = (0, vue_3.ref)(0);
        var aib = (0, vue_3.ref)('');
        var payment = (0, vue_3.ref)('');
        var type = (0, vue_3.ref)('FV');
        var status = (0, vue_3.ref)('draft');
        var client = (0, vue_3.ref)(null);
        var enterprise = (0, vue_3.ref)(null);
        var errors = (0, vue_3.ref)(null);
        var addService = function () {
            services.value.push({ service_id: 0, price: 0, quantity: 0, total: 0, specific_tax: 0 });
        };
        var deleteService = function (index) {
            services.value.splice(index, 1);
        };
        function setItemTotal(item, index) {
            services.value[index] = item;
        }
        var total = (0, vue_3.computed)(function () {
            return services.value.reduce(function (p, curr) { return p + curr.total; }, 0) - discount.value;
        });
        var createInvoice = function () {
            var invoice = {
                client_id: client.value,
                enterprise_id: enterprise.value,
                aib: aib.value,
                discount: discount.value,
                type: type.value,
                status: status.value,
                payment_method: payment.value,
                items: services.value
            };
            globalThis.axios
                .post('/api/invoices', invoice)
                .then(function (resp) {
                location.href = '/invoices';
            })
                .catch(function (err) {
                errors.value = err.response.data.message;
                console.log('erreur: ', { err: err });
            });
        };
        (0, vue_3.onMounted)(function () {
            globalThis.axios.get('/sanctum/csrf-cookie');
        });
        (0, vue_3.provide)('sumTotal', setItemTotal);
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (errors.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)(errors.value), 1)
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("div", _hoisted_5, [
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        _hoisted_7,
                        (0, vue_2.createVNode)(CompanySelector_vue_1.default, {
                            onSelected: _cache[0] || (_cache[0] = function ($event) { return (enterprise.value = $event); })
                        })
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                        _hoisted_9,
                        (0, vue_2.createVNode)(ClientSelector_vue_1.default, {
                            onSelected: _cache[1] || (_cache[1] = function ($event) { return (client.value = $event); })
                        })
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_10, [
                    (0, vue_2.createElementVNode)("div", _hoisted_11, [
                        (0, vue_2.createElementVNode)("table", _hoisted_12, [
                            _hoisted_13,
                            (0, vue_2.createElementVNode)("tbody", null, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(services.value, function (service, index) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ServiceItem_vue_1.default, {
                                        onRemoved: function ($event) { return (deleteService(index)); },
                                        index: index
                                    }, null, 8, ["onRemoved", "index"]));
                                }), 256)),
                                (0, vue_2.createElementVNode)("tr", {
                                    onClick: addService,
                                    class: "add-service"
                                }, _hoisted_15)
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_16, [
                        (0, vue_2.createElementVNode)("ul", _hoisted_17, [
                            (0, vue_2.createElementVNode)("li", _hoisted_18, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((aib).value = $event); }),
                                    class: "form-select",
                                    "aria-label": "Default select example",
                                    id: "aib",
                                    name: "aib"
                                }, _hoisted_22, 512), [
                                    [vue_2.vModelSelect, aib.value]
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("li", _hoisted_23, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((payment).value = $event); }),
                                    name: "payment_method",
                                    id: "payment_method",
                                    class: "form-select",
                                    "aria-label": "Default select example"
                                }, _hoisted_32, 512), [
                                    [vue_2.vModelSelect, payment.value]
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("li", _hoisted_33, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((type).value = $event); }),
                                    name: "type",
                                    id: "type",
                                    class: "form-select",
                                    "aria-label": "Default select example"
                                }, _hoisted_36, 512), [
                                    [vue_2.vModelSelect, type.value]
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("li", _hoisted_37, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((status).value = $event); }),
                                    name: "status",
                                    id: "status",
                                    class: "form-select",
                                    "aria-label": "Default select example"
                                }, _hoisted_40, 512), [
                                    [vue_2.vModelSelect, status.value]
                                ])
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_41, [
                        (0, vue_2.createElementVNode)("div", _hoisted_42, [
                            _hoisted_43,
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((discount).value = $event); }),
                                type: "number",
                                name: "discount",
                                id: "discount",
                                class: "form-control",
                                placeholder: "Remise",
                                min: "0",
                                step: "1",
                                title: "Remise"
                            }, null, 512), [
                                [vue_2.vModelText, discount.value]
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("ul", _hoisted_44, [
                            _hoisted_45,
                            (0, vue_2.createElementVNode)("li", _hoisted_46, [
                                _hoisted_47,
                                (0, vue_2.createElementVNode)("span", _hoisted_48, (0, vue_2.toDisplayString)((0, vue_2.unref)(total)), 1)
                            ]),
                            (0, vue_2.createElementVNode)("li", _hoisted_49, [
                                _hoisted_50,
                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(total)) + " Fcfa", 1),
                                (0, vue_2.createElementVNode)("input", {
                                    type: "hidden",
                                    name: "total",
                                    value: (0, vue_2.unref)(total)
                                }, null, 8, _hoisted_51)
                            ])
                        ])
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", { class: "row" }, [
                    (0, vue_2.createElementVNode)("div", { class: "col-auto" }, [
                        (0, vue_2.createElementVNode)("button", {
                            onClick: createInvoice,
                            type: "button",
                            class: "btn btn-primary"
                        }, "Enregistrer")
                    ])
                ])
            ]));
        };
    }
});
